import React, { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../../components/Layout';
import IDEImage from '../../assets/GridCard/ide.svg';
import SEO from '../../components/seo';

import SideBar from '../../components/SideBar/SideBar';
import ConnectAndContribute from '../../components/ConnectAndContribute/ConnectAndContribute';

import '../software.scss';
import { getSoftwareSideBarDataRefactored } from '../../utils/functions';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { BACK, SOFTWARE_IDE_PAGE, SOFTWARE_PAGE } from '../../utils/constants';
import ProductSWBanner from '../../components/ProductSWbanner/ProductSWBanner';
import { IconArrowUpRightTeal } from '../../components/Icons';
import ProductTutorials from '../../components/ProductTutorials/ProductTutorials';
import { TabsHeader } from '../../components/TabsHeader/TabsHeader';

interface SoftwareProps {
  file: {
    childMdx: any;
    frontmatter: {
      title: string;
    };
  };
  softwarePages: any;
  softwareSubpages: any;
}

export default function Ide(): React.ReactElement {
  const data: SoftwareProps = useStaticQuery(pageQuery);

  const softwareRefactoredData = useMemo(() => {
    return getSoftwareSideBarDataRefactored(data);
  }, [data]);

  const tabsData = useMemo(() => {
    return [
      {
        title: 'Arduino IDE 2',
        url: 'ide-v2',
        children: <ProductTutorials type="Arduino IDE 2" data={softwareRefactoredData} />,
      },
      {
        title: 'Legacy IDE',
        url: 'ide-v1',
        children: <ProductTutorials type="Legacy IDE" data={softwareRefactoredData} />,
      },
    ];
  }, [softwareRefactoredData]);

  return (
    <Layout>
      <SEO title="Arduino IDE" description="Discover all the features of the Arduino IDE, our most popular programming tool." />
      <main className="page-container">
        <SideBar
          links={[]}
          prevPage={{
            title: BACK,
            pathname: SOFTWARE_PAGE,
          }}
          nestedCategories={softwareRefactoredData}
          actualPage={'Software tools'}
        />
        <div className="page-layout software">
          <Breadcrumbs
            actualPage={'Arduino IDE'}
            list={[
              { title: 'Home', url: '/' },
              { title: 'Software', url: SOFTWARE_PAGE },
              { title: 'Arduino IDE', url: SOFTWARE_IDE_PAGE },
            ]}
          />
          <ProductSWBanner
            title="Arduino IDE"
            description="Discover all the features of the Arduino IDE, our most popular programming tool."
            image={IDEImage}
            cta={[
              {
                url: 'https://www.arduino.cc/en/software',
                label: 'Download',
                icon: <IconArrowUpRightTeal />,
                external: true,
                primary: true,
              },
            ]}
          />
          <TabsHeader tabs={tabsData} activeTab="Arduino IDE 2" />
          <ConnectAndContribute />
        </div>
      </main>
    </Layout>
  );
}

export const pageQuery = graphql`
  {
    softwarePages: allFile(filter: { fields: { type: { eq: "software" } } }, sort: { relativeDirectory: ASC }) {
      edges {
        node {
          relativeDirectory
          name
          fields {
            slug
          }
          childMdx {
            frontmatter {
              title
              description
              icon
            }
          }
        }
      }
    }
    softwareSubpages: allFile(filter: { fields: { type: { eq: "softwarepage" } } }, sort: { relativeDirectory: ASC }) {
      edges {
        node {
          relativeDirectory
          name
          fields {
            slug
          }
          childMdx {
            frontmatter {
              title
              description
              icon
            }
          }
        }
      }
    }
  }
`;
